import React, { PureComponent } from 'react'
import classnames from 'classnames'

import { scrollTo } from './services/utils'

import './Loader.css'

export default class Loader extends PureComponent {
  componentDidMount() {
    scrollTo(this.element, 'bottom')
  }

  render() {
    const { loading } = this.props
    const classes = classnames('cm-loader', {
      'cm-loader__loading': loading
    })
    return <div ref={el => (this.element = el)} className={classes} />
  }
}



// WEBPACK FOOTER //
// ./src/Loader.js